export default function EmptyState({ icon, title, description, action, compact = false }) {
  return (
    <div
      className="text-center"
      style={{
        padding: compact ? '32px 16px' : '64px 16px',
        color: 'var(--ink3)',
      }}
    >
      {icon && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '14px',
            opacity: 0.35,
            color: 'var(--ink2)',
          }}
        >
          {icon}
        </div>
      )}
      {title && (
        <p style={{ fontSize: '14px', fontWeight: 600, color: 'var(--ink2)', marginBottom: description || action ? '6px' : 0 }}>
          {title}
        </p>
      )}
      {description && (
        <p
          style={{
            fontSize: '12px',
            color: 'var(--ink3)',
            maxWidth: '320px',
            margin: '0 auto',
            marginBottom: action ? '18px' : 0,
            lineHeight: 1.5,
          }}
        >
          {description}
        </p>
      )}
      {action && (
        <div className="flex justify-center">
          {action}
        </div>
      )}
    </div>
  );
}
